import { render, staticRenderFns } from "./MediaPremiumToggle.vue?vue&type=template&id=baea8420"
import script from "./MediaPremiumToggle.vue?vue&type=script&lang=js"
export * from "./MediaPremiumToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports